import { formatNumber } from '@lichtblick/localization';

const optionallyFormatNumber = (value: number, format = true) => (format ? formatNumber(value) : value);

export const i18n = {
  validation: {
    differingEmail: 'Die E-Mail-Adressen stimmen nicht überein.',
    missing: 'Hier fehlt noch eine Angabe.',
    invalid: 'Hier stimmt etwas nicht.',
    invalidEmail: 'Ungültige E-Mail-Adresse.',
    invalidMinimum: (min: number) => `Der Wert muss mindestens ${min} betragen.`,
    invalidPostalCode: 'Ungültige Postleitzahl.',
    invalidPhoneNumber:
      'Bitte achte darauf, dass die Telefonnummer mit einem + oder einer 0 startet, mindestens 6 Ziffern hat und mit einer Ziffer endet.',
    invalidRange: (min: number, max: number, format = true) =>
      `Der Wert muss zwischen ${optionallyFormatNumber(min, format)} und ${optionallyFormatNumber(max, format)} liegen.`,
  },
  form: {
    submit: 'Jetzt abschicken',
  },
} as const;
